export default "__VITE_ASSET__CLWUHyHo__"